import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ManageProfileFormComponent } from './manage-profile-form/manage-profile-form.component';

const routes: Routes = [
  {
    path: '',
    component: ManageProfileFormComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ManageProfileRoutingModule { }
